import { shape, string } from 'prop-types';
import { Modal, Button, Segment, Icon } from 'semantic-ui-react';
import React, { useEffect, useState } from 'react';
import Space from 'Modules/Space';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmModal from 'Modules/ConfirmModal/ConfirmModal';
import useVoidCert from 'Hooks/teleconsult/useVoidCert';
import { CERT_VOIDED_STATUS } from 'Constants/commons';

import MCDigiPreviewContent from './MCDigiPreviewContent';
import useDigiMcPreview from './useDigiMcPreview';
import ErrorModal from './ErrorModal';

const MCDigiPreviewModal = ({ data }) => {
  const dispatch = useDispatch();
  const { id: drId } = useSelector(state => state.doctors.profile);

  const [showVoidConfirmModal, setShowVoidConfirmModal] = useState(false);
  const [errorModal, setErrorModal] = useState({
    open: false,
    errorMsg: '',
  });

  const { voidACert, loading: voidingDigiMC } = useVoidCert();

  const { certId, onClose } = data;
  const { certDetail, getCertDetail, loading: loadingDigiMC } = useDigiMcPreview(certId);

  const allowToVoid =
    certDetail?.id === certId &&
    certDetail?.doctorId === drId &&
    certDetail?.status !== CERT_VOIDED_STATUS;

  const handleVoidCert = async () => {
    try {
      await voidACert(certId);
      onClose();
    } catch (e) {
      setErrorModal({
        open: true,
        errorMsg: e?.data?.message || 'An error occurred while voiding the MC.',
      });
    } finally {
      setShowVoidConfirmModal(false);
    }
  };

  useEffect(() => {
    getCertDetail();
  }, [certId, dispatch]);

  return (
    <>
      <Modal open closeIcon onClose={onClose} closeOnDimmerClick={false} style={{ width: '760px' }}>
        <Modal.Header>Medical Certificate - Digi MC</Modal.Header>
        <Modal.Content>
          {loadingDigiMC ? (
            <Segment basic loading style={{ minHeight: 450 }} />
          ) : (
            <MCDigiPreviewContent certDetail={certDetail} style={{ minHeight: 450 }} />
          )}
        </Modal.Content>
        {allowToVoid && (
          <Modal.Actions>
            <Button
              style={{ fontWeight: 600 }}
              basic
              icon
              color="red"
              onClick={() => setShowVoidConfirmModal(true)}>
              <Space size={4} direction="horizontal">
                <Icon name="trash alternate outline" />
                Void
              </Space>
            </Button>
          </Modal.Actions>
        )}
      </Modal>

      <ConfirmModal
        title="Void MC"
        message="By proceeding, this MC will be voided and this action cannot be undone."
        confirmButtonText="Void"
        showModal={showVoidConfirmModal}
        onSubmit={handleVoidCert}
        onClose={() => setShowVoidConfirmModal(false)}
        loading={voidingDigiMC}
      />

      <ErrorModal
        open={errorModal.open}
        errorMsg={errorModal.errorMsg}
        title="Cannot void MC"
        onClose={() => setErrorModal({ open: false, errorMsg: '' })}
      />
    </>
  );
};

MCDigiPreviewModal.propTypes = {
  data: shape({
    certId: string,
  }),
};

export default MCDigiPreviewModal;
